import { QUERY_PARAMS_FOR_BOOKMARK } from "../../app/constants/api.constant";
import { ILoginInformation } from "../../app/interfaces/ILoginInformation.interface";
import { ITokenResponse } from "../../app/interfaces/ITokenResponse.interface";
import { paths } from "../../app/routes/paths";
import { loadState } from "../../app/utils/persistState/loadState";

// The backend binds a missing/empty patient route segment to Guid.Empty, which
// then 404s ("Patient with id 00000000-... was not found"). Treat that value —
// and the string forms that leak through the URL — as "no patient". YAP-9869.
export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export const isValidPatientId = (patientId?: string): boolean =>
  Boolean(patientId) &&
  patientId !== EMPTY_GUID &&
  patientId !== "undefined" &&
  patientId !== "null";

// Where to send a login attempt that has no real patient (e.g. the login page
// was reached with a stale/empty query). A shared in-office/registered device
// returns to its idle device page so it stays reusable for the next patient;
// anything else falls back to the expired-link page. YAP-9869.
export const getInvalidPatientRedirect = (): string => {
  if (loadState("patientEntryMode") === "registeredDevice") {
    const bookmark = sessionStorage.getItem(QUERY_PARAMS_FOR_BOOKMARK);
    // Only send the device to its idle page when we still have the bookmark to
    // re-register it; a bare /register-device would just render an error page.
    if (bookmark) return `${paths.registerDevice}${bookmark}`;
  }
  return paths.expiredLinkPage;
};

export const getFirstAndLastName = (data: ILoginInformation): string => {
  if (!data) return;
  const {
    patientResponse: { firstName, lastName },
  } = data;

  return `${firstName} ${lastName.charAt(0)}.`;
};

export const setCredentialsToSessionStorage = (data: ITokenResponse) => {
  Object.entries(data).forEach(([key, value]) => {
    sessionStorage.setItem(key, value);
  });
};
